var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsxs, jsx } from "react/jsx-runtime";
import "../../Styling.js";
import { Stack } from "@fluentui/react/lib/Stack";
import "../Heading.js";
import { mergeStyles } from "@fluentui/style-utilities";
import { PageTitle } from "../Heading/PageTitle.js";
const defaultClassName = "ane-FormHeading";
const FormHeading = (_a) => {
  var _b = _a, { className, pageTitle, children } = _b, rest = __objRest(_b, ["className", "pageTitle", "children"]);
  return /* @__PURE__ */ jsxs(
    Stack,
    __spreadProps(__spreadValues({
      className: mergeStyles(
        defaultClassName,
        {
          marginBottom: "24px"
        },
        className
      ),
      tokens: { childrenGap: 24 }
    }, rest), {
      children: [
        !!pageTitle && /* @__PURE__ */ jsx(
          PageTitle,
          {
            className: mergeStyles(`${defaultClassName}-heading`, {
              marginBottom: 0
            }),
            children: pageTitle
          }
        ),
        !!children && /* @__PURE__ */ jsx(
          "div",
          {
            className: mergeStyles(`${defaultClassName}-description`, {
              lineHeight: "20px",
              fontSize: "14px",
              p: {
                marginTop: "0",
                marginBottom: "0"
              },
              "p:not(:first-child)": {
                marginTop: "20px",
                marginBottom: "0"
              }
            }),
            children: typeof children === "string" ? /* @__PURE__ */ jsx("p", { children }) : children
          }
        )
      ]
    })
  );
};
export {
  FormHeading,
  FormHeading as default
};
//# sourceMappingURL=FormHeading.js.map
